<template>
  <div id="app" :style="{ 'overflow': $route.name === 'live' ? 'hidden' : '' }">
    <bar/>
    <keep-alive :include="['recommend']">
      <router-view/>
    </keep-alive>
    <tab-bar/>
    <global-loading/>
    <global-popup/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Bar from './components/Bar.vue'
import TabBar from './components/TabBar.vue'
import GlobalPopup from './components/UI/Popup.vue'
import api from '@edu-fe/api'

export default {
  computed: mapState(['errMessage']),
  methods: mapActions(['getUserInfo']),
  components: {
    Bar,
    TabBar,
    GlobalPopup
  },

  data () {
    return {
      messageTime: 0,
    }
  },
  created () {
    const loginTime = window.sessionStorage.getItem('loginTime')
    if (loginTime) {
      const now = new Date().getTime()
      // api.mine.reportLogin(now - loginTime)()
      window.sessionStorage.removeItem('loginTime')
    }
  },
  watch: {
    errMessage (n) {
      if (n[0] > 0 && n[0] > this.messageTime) {
        this.$toast.show({
          message: typeof n[1] === 'object' ? n[1].message : n[1],
          keep: 3001
        })
        this.messageTime ++
      }
    }
  }
}
</script>

<style lang="scss">
@import "./style/global";
</style>
